export default __webpack_public_path__ + "static/media/lif3-symbol.97dbaad5.svg";